var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-loader",style:({width: _vm.width, height: _vm.height, 'border-radius': _vm.radius})},[_c('div',{staticClass:"gradient"})])}
var staticRenderFns = []

export { render, staticRenderFns }